import { Theme } from '@mui/material/styles';

export default function IconButton(theme: Theme) {
    return {
        MuiIconButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.size === 'small' && {
                        height: theme.componentSizes.small,
                        width: theme.componentSizes.small,
                    }),
                    ...(ownerState.size === 'medium' && {
                        height: theme.componentSizes.medium,
                        width: theme.componentSizes.medium,
                    }),
                    '&:focus': {
                        outline: 'none',
                    },
                    '&:focus-visible': {
                        outline: 'none',
                        boxShadow: 'none',
                    },
                    '&.Mui-focusVisible': {
                        outline: 'none',
                        boxShadow: 'none',
                    },
                }),
            },
        },
    };
}
